import React from "react";
// Apne actual path se import karein


const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col min-h-screen">


      {/* Main Content - pt-32 se header ke saath overlap khatam ho jayega */}
      <main className="flex-grow bg-gray-50 pt-32 pb-16 px-4 md:px-8">
        <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">

          {/* Page Heading */}
          <div className="mb-10 pb-6 border-b border-gray-200">
            <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Privacy Policy</h1>
            <p className="text-gray-500 text-sm">Last Updated: June 13, 2026</p>
          </div>

          {/* Policy Content */}
          <div className="space-y-8 text-gray-700 leading-relaxed">

            <section>
              <h2 className="text-2xl font-bold text-orange-600 mb-4">1. SMS Consent & Mobile Information</h2>
              <p>
                At <strong>VitalSource WholeSale LLC DBA </strong>, we respect your privacy and are committed to protecting your personal information.
              </p>
              <div className="mt-4 p-6 bg-orange-50 border-l-4 border-orange-500 rounded-r-xl">
                <p>
                  By providing your phone number and opting into SMS communications, you consent to receive text messages from VitalSource Wholesale LLC, including but not limited to:

                  Delivery Notifications – Updates regarding the shipment and delivery status of your orders
                  Order Confirmations – Confirmation of purchases and transactions
                  Customer Support – Responses to inquiries submitted through our website
                  Service Updates – Important updates related to your account or our services                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Data Confidentiality</h2>
              <p>
                Mobile opt-in data and consent will not be shared with third parties or affiliates for marketing or promotional purposes. All text messaging originator opt-in data and consent information will remain confidential and will not be shared with any third parties.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Your Control</h2>
              <p>
                Message frequency may vary depending on your order and account activity. Message and data rates may apply. You may opt out of SMS communications at any time by replying STOP to any message. For assistance, reply HELP or contact us at +1 (317) 245-6309.
                Opting out will not affect your ability to receive order-related communications through other channels (email, etc.).  </p>
            </section>

          </div>
        </div>
      </main>


    </div>
  );
};

export default PrivacyPolicy;